import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class UrlHistoryService {
  constructor(private _router: Router) {}

  public replaceState(data: any, title?: string, url?: string | null) {
    history.replaceState(data, title, url);
  }

  public pushState(data: any, title?: string, url?: string | null) {
    history.pushState(data, title, url);
  }

  public replaceUrl(url) {
    if (url) {
      this._router.navigateByUrl(url, { replaceUrl: true });
    }
  }
}
